export default __webpack_public_path__ + "static/media/PPI-garden-bed-004.fa6c5ea6.jpg";